/**
 * Configuração do ambiente, tipada e validada na inicialização.
 *
 * Falhar aqui, no boot, é melhor do que descobrir a variável ausente em
 * uma chamada de rede qualquer no meio do fluxo do usuário.
 *
 * Só entram variáveis `VITE_*` — elas vão para o bundle e são públicas
 * por definição. Nenhum segredo pode ser lido deste módulo: chave secreta
 * do Supabase, API key do Asaas e do OpenAI vivem exclusivamente no
 * servidor (Edge Functions e worker).
 */

function required(name: keyof ImportMetaEnv): string {
  const value: unknown = import.meta.env[name];
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(
      `Variável de ambiente ausente: ${String(name)}. ` +
        `Copie apps/web/.env.example para apps/web/.env e preencha.`,
    );
  }
  return value;
}

export const env = {
  supabaseUrl: required('VITE_SUPABASE_URL'),
  supabasePublishableKey: required('VITE_SUPABASE_PUBLISHABLE_KEY'),
  appName: import.meta.env.VITE_APP_NAME || 'Zelo IA',
  workerBaseUrl: import.meta.env.VITE_WORKER_BASE_URL ?? '',
  /**
   * Mostrar os bancos de TESTE da Pluggy no conector.
   *
   * Só em homologação. Em produção a variável não é definida e isto fica
   * falso — ver o comentário em `pluggy.service.ts`.
   */
  pluggySandbox: import.meta.env.VITE_PLUGGY_SANDBOX === 'true',
  isDev: import.meta.env.DEV,
} as const;
